export default {
  DEFAULT: 'DEFAULT',
  NULL: 'NULL'
};
